import { useState } from 'react';

const useCustomHook = () => {
  const [methodType, setMethodtype] = useState('wallet');
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const [isBulk, setIsBulk] = useState(false);
  const [isGroup, setIsGroup] = useState(false);
  const [expireDate, setExpireDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [rowsWithError, setRowsWithError] = useState([]);
  const [isResultErrorsOpen, setIsResultErrorsOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [guilds, setGuilds] = useState([]);
  const [usages, setUsages] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [usageEnabled, setUsageEnabled] = useState(false);
  const [periodicEnabled, setPeriodicEnabled] = useState(false);
  const [usageLimitsEnabled, setUsageLimitsEnabled] = useState(false);
  const [usagePeriodEnabled, setUsagePeriodEnabled] = useState(false);
  const [balance, setBalance] = useState(null);
  const [foundUser, setFoundUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isDisableSubmit, setIsDisableSubmit] = useState(false);
  const [keyType, setKeyType] = useState(null); // wallet / credit
  const [dataType, setDataType,] = useState('');
  const [infoType, setInfoType] = useState('نام کاربری');
  const [captchaIdDialog, setCaptchaIdDialog] = useState(null); //مقدار کپچا در دیالوگ 
  const [enteredCaptcha, setEnteredCaptcha] = useState(''); // شناسه کپچا در دیالوگ اولیه 
  const [captchaIdForm, setCaptchaIdForm] = useState(null); //مقدار کپچا در  فرم گروهی
  const [enteredCaptchaForm, setEnteredCaptchaForm] = useState(''); // شناسه کپچا در  فرم گروهی 
  const [isOpenCartableMessageDg, setIsOpenCartableMessageDg] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [dataCartable, setDataCartable] = useState(null); // سرویس کارتابل لیست کال میشود و اگر کارتابل باشد اطلاعات داخل این فیلد قرار میگیرد
  const [isCartableLoading, setIsCartableLoading] = useState(false);
  const [isCartable, setIsCartable] = useState(false);
  const [groupRequestId, setGroupRequestId] = useState(null);
  const [isLoadingAcceptReaptiveDg, setIsLoadingAcceptReaptiveDg] = useState(false); // لودینگ بودن دکمه تایید
  const [enteredCaptchaRepeat, setEnteredCaptchaRepeat] = useState(''); // محتویات وارد شده در تکس باکس کپچا دیالوگ فایل تکراری
  const [isOpenRepeativeDg, setIsOpenRepeativeDg] = useState(false); // باز و بسته شدن دیالوگ فایل تکراری
  const [captchaIdDialogRepeat, setCaptchaIdDialogRepeat] = useState(null); // محتویات کپچا آیدی دیالوگ فایل تکراری 
  return {
    methodType,
    setMethodtype,
    selectCheckBox,
    setSelectCheckBox,
    isBulk,
    setIsBulk,
    isGroup,
    setIsGroup,
    expireDate,
    setExpireDate,
    startDate,
    setStartDate,
    rowsWithError,
    setRowsWithError,
    isResultErrorsOpen,
    setIsResultErrorsOpen,
    file,
    setFile,
    guilds,
    setGuilds,
    usages,
    setUsages,
    selectedProducts,
    setSelectedProducts,
    usageEnabled,
    setUsageEnabled,
    periodicEnabled,
    setPeriodicEnabled,
    usageLimitsEnabled,
    setUsageLimitsEnabled,
    usagePeriodEnabled,
    setUsagePeriodEnabled,
    balance,
    setBalance,
    foundUser,
    setFoundUser,
    loading,
    setLoading,
    submitting,
    setSubmitting,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    activeStep,
    setActiveStep,
    isDisableSubmit, setIsDisableSubmit,
    keyType, setKeyType,
    captchaIdDialog, setCaptchaIdDialog,
    enteredCaptcha, setEnteredCaptcha,
    isOpenCartableMessageDg,
    setIsOpenCartableMessageDg,
    requestId,
    setRequestId,
    dataCartable, setDataCartable,
    isCartableLoading, setIsCartableLoading,
    isCartable, setIsCartable,
    dataType, setDataType,
    captchaIdForm, setCaptchaIdForm,
    enteredCaptchaForm, setEnteredCaptchaForm,
    groupRequestId, setGroupRequestId,
    infoType, setInfoType,
    isLoadingAcceptReaptiveDg, setIsLoadingAcceptReaptiveDg,
    enteredCaptchaRepeat, setEnteredCaptchaRepeat,
    isOpenRepeativeDg, setIsOpenRepeativeDg,
    captchaIdDialogRepeat, setCaptchaIdDialogRepeat,
  };
};

export default useCustomHook;
